// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3z9Oj","productName":"Table_productName__1DiGN"};